export default "__VITE_ASSET__Q8ezhWJx__"